import { render, staticRenderFns } from "./ProviderBody.vue?vue&type=template&id=d4fb730e&"
import script from "./ProviderBody.vue?vue&type=script&lang=ts&"
export * from "./ProviderBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports